import React from "react";
import { generateSequentialArray } from "../../utils";
import { AnimationLoading } from "./LoadingSidebarStyled";

interface Props {
  numItems?: number;
}
export const LoadingSidebar = (props: Props) => {
  const { numItems } = props;
  const auxiliaryArray = generateSequentialArray(numItems ? numItems : 8);
  return (
    <div>
      {auxiliaryArray.map((_, index) => (
        <AnimationLoading key={index} />
      ))}
    </div>
  );
};
